@use '@/styles/mastodon/mixins';

.badge.badge {
  @include mixins.type-micro;

  line-height: 1.1;

  &:not(.badgeWithoutIcon) {
    padding-inline: var(--space-half) var(--space-1);
  }
}
